export default {
  MEMBER: 'MEMBER',
  SUPERVISOR: 'SUPERVISOR',
};
